import React, { Component } from "react"
import PropTypes from "prop-types"

export class Label extends Component {
  static propTypes = {
    children: PropTypes.oneOfType([
      PropTypes.arrayOf(PropTypes.node),
      PropTypes.node
    ])
  }

  render() {
    const { children, ...labelProps } = this.props
    return (
      <label
        {...labelProps}
        className="text-xs font-semibold font-sans leading-snug text-gray-800 whitespace-nowrap mb-1"
      >
        {children}
      </label>
    )
  }
}
